//
// Hierarchy.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./Level";
import "../tree/DataTreeNode";

var Hierarchy = createModule("commons::Hierarchy", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getName: [7],
        getLabel: [7],
        isFromRelational: [2],
        canDrillUp: [2],
        canCollapse: [2,1],
        _drillDown_o: [0,1],
        getLevels: [[1]],
        _canDrillDown_v: [2],
        canExpand: [2,1],
        getCurrentLevel: [1],
        _drillDown_os: [0,1,7],
        getCurrentLevelIndex: [4],
        _canDrillDown_o: [2,1],
        expand: [0,1],
        getExpandedState: [1],
        getOneLevelUp: [1],
        getLevelWithName: [1,7],
        getOneLevelDown: [1],
        isDrillable: [2],
        collapse: [0,1],
    },
    {
        _create_sso: [4,7,7,[1]],
    },
    ["drillDown","canDrillDown"],
    ["_create"]
]);
export default Hierarchy;
